var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],class:'square' + (_vm.disabled ? ' disabled' : ''),style:({
    width: _vm.size + 'px',
    height: _vm.size + 'px',
    lineHeight: _vm.size + 8 + 'px'
  }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }